import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
// swiper css
import "swiper/css";
import "swiper/css/pagination";

const Trending = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <section className="section bg-light" id="categories">
                <Container fluid>
                    <Row className="justify-content-center">
                        <Col lg={5}>
                            <div className="text-center mb-5">
                                <h2 className="mb-3 fw-semibold lh-base">
                                    {t("trending.title")}
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col lg={9}>
                            <Row>
                                {[1, 2, 3].map((i) => (
                                    <Col lg={4} className="product-item" key={i}>
                                        <div className="card explore-box card-animate h-100">
                                            <div className="text-center mt-4 p-2">
                                                <span className="rounded-circle badge badge-soft-success p-3">
                                                    <i
                                                        className={
                                                            i === 1
                                                                ? "ri-user-follow-fill"
                                                                : i === 2
                                                                    ? "ri-smartphone-line"
                                                                    : "ri-eye-fill"
                                                        }
                                                        style={{ fontSize: "3rem" }}
                                                    ></i>
                                                </span>
                                            </div>
                                            <div className="card-body">
                                                <h3 className="text-center">{t(`trending.card${i}.title`)}</h3>
                                                <p className="text-muted my-2 text-center fs-17 py-3">
                                                    {t(`trending.card${i}.text`)}
                                                </p>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Trending;
